import ConfirmationModal from '../ConfirmationModal'

export type DeleteModalProps = {
  open: boolean
  onClose: () => void
  count: number
  onConfirm: () => void
}

export const DeleteModal = ({ open, onConfirm, onClose, count }: DeleteModalProps) => (
  <ConfirmationModal
    open={open}
    title="Deleting Content"
    subtitle={
      <>
        Are you sure you want to delete these <br />
        {count} items? This action cannot be changed.
      </>
    }
    onClose={onClose}
    onConfirm={onConfirm}
    confirmText="Confirm Deleting"
  />
)
